document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    const closeMenu = () => {
      mobileMenu.hidden = true;
      menuToggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
      menuToggle.focus();
    };
    menuToggle.addEventListener('click', () => {
      const open = mobileMenu.hidden;
      mobileMenu.hidden = !open;
      menuToggle.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('menu-open', open);
      if (open) mobileMenu.querySelector('[data-menu-close]')?.focus();
    });
    mobileMenu.querySelector('[data-menu-close]')?.addEventListener('click', closeMenu);
    mobileMenu.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !mobileMenu.hidden) closeMenu();
    });
  }

  const gift = document.querySelector('[data-welcome-gift]');
  if (gift) {
    const hasWelcomeSuccess = Boolean(gift.querySelector('[data-welcome-success]'));
    if (hasWelcomeSuccess) {
      gift.hidden = false;
      gift.classList.add('is-success');
    } else if (!sessionStorage.getItem('nelora-welcome-dismissed')) {
    const hero = document.querySelector('[data-hero]');
    let delayComplete = false;
    const revealGift = () => {
      if (!delayComplete || (hero && window.scrollY < hero.offsetHeight - 80)) return;
      gift.hidden = false;
      window.removeEventListener('scroll', revealGift);
    };
    window.setTimeout(() => { delayComplete = true; revealGift(); }, Number(gift.dataset.delay || 4000));
    window.addEventListener('scroll', revealGift, { passive: true });
      gift.querySelector('[data-welcome-close]')?.addEventListener('click', () => {
        gift.hidden = true;
        sessionStorage.setItem('nelora-welcome-dismissed', 'true');
      });
    }
  }

  document.querySelectorAll('[data-product]').forEach((root) => {
    const variantsNode = root.querySelector('[data-product-variants]');
    if (!variantsNode) return;
    const variants = JSON.parse(variantsNode.textContent);
    const selected = [...root.querySelectorAll('[data-option-value].is-selected')].map((button) => button.dataset.optionValue);
    const variantInput = root.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-price]');
    const add = root.querySelector('.product-page__add');
    const showMedia = (id) => {
      root.querySelectorAll('[data-media-id]').forEach((node) => node.classList.toggle('is-active', String(node.dataset.mediaId) === String(id)));
      root.querySelectorAll('[data-media-trigger]').forEach((node) => node.classList.toggle('is-active', String(node.dataset.mediaTrigger) === String(id)));
    };
    root.querySelectorAll('[data-media-trigger]').forEach((button) => button.addEventListener('click', () => showMedia(button.dataset.mediaTrigger)));
    root.querySelectorAll('[data-option-value]').forEach((button) => button.addEventListener('click', () => {
      const fieldset = button.closest('fieldset');
      fieldset.querySelectorAll('[data-option-value]').forEach((node) => {
        node.classList.remove('is-selected');
        node.setAttribute('aria-pressed', 'false');
      });
      button.classList.add('is-selected');
      button.setAttribute('aria-pressed', 'true');
      const values = [...root.querySelectorAll('[data-option-value].is-selected')].map((node) => node.dataset.optionValue);
      const variant = variants.find((entry) => entry.options.every((value, index) => value === values[index]));
      if (!variant) return;
      variantInput.value = variant.id;
      price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(variant.price / 100);
      add.disabled = !variant.available;
      add.textContent = variant.available ? 'Add to bag' : 'Sold out';
      if (variant.featured_media?.id) showMedia(variant.featured_media.id);
      window.history.replaceState({}, '', `${window.location.pathname}?variant=${variant.id}`);
    }));
  });
});
